module.exports = __webpack_public_path__ + "img/70-Metbrush Silver.jpg";